import { useMemo } from 'react';
import { AdminStore } from 'services/api/admin';

export type Store = Pick<
  AdminStore,
  'id' | 'externalId' | 'storeName' | 'alias' | 'externalType' | 'region'
>;

export interface Active {
  platform: General.PlatformUpperCaseTunnel;
  region: General.UpperCaseRegion | 'all';
}

export interface PlatformConfig {
  platform: General.PlatformUpperCaseTunnel;
  count: number;
  regionList: RegionConfig[];
}

export interface RegionConfig {
  region: General.UpperCaseRegion;
  count: number;
}

export type Mode = 'platform' | 'import';

export interface StoreScopesFormValues {
  mode: Mode;
  storeScopes: General.StoreScope[];
  active?: Active;
  assets: {
    storeMap: Partial<Record<string, Store>>;
    wabaMap: Partial<Record<string, WhatsappBusinessApi.Account>>;
  };
}

export type FV = StoreScopesFormValues;

export const useStoreMap = <P extends Store>({
  list,
  map,
}: {
  list?: P[];
  map?: Partial<Record<number, P>>;
}) => {
  return useMemo(() => {
    return (
      map ||
      (list || []).reduce<Partial<Record<number, P>>>((res, store) => {
        res[store.id] = store;

        return res;
      }, {})
    );
  }, [map, list]);
};
